<app-svg-load-morph-animation></app-svg-load-morph-animation>

<app-generic-side-modal-container [sideNavTitleText]="'Employees' | translate" class="min-w-[75vw]">

  <div mainPageContent class="overflow-clip">
    <div class="padding_20">

      <div class="flex flex-col lg:flex-row gap-5 justify-between items-baseline">
        <h1 class="uppercase text-[#475569] font-bold text-3xl lg:text-4xl w-full">{{"Shifts schedule" | translate}}
        </h1>

        <div class="flex flex-col gap-1 w-full mb-[.5rem] lg:w-[40%]">
          <mat-label>{{"Select employee" | translate}}</mat-label>
          <mat-form-field appearance="outline" class="flex flex-row items-center">

            <mat-icon matPrefix><i class="fa-regular fa-user text-[2rem] pr-[1rem]"></i> </mat-icon>

            <mat-select [(ngModel)]="employeeProfileId" (selectionChange)="employeeSelectionChange($event)"
              placeholder='{{"select" | translate}}' [ngModelOptions]="{standalone: true}">
              <mat-option [value]="null"> {{"Show all" | translate}} </mat-option>
              <mat-option *ngFor="let employee of employeeData" [value]="employee.profileId"> {{ employee.name }} {{
                employee.surname }} </mat-option>
            </mat-select>

          </mat-form-field>
        </div>
      </div>

      <full-calendar #calendar class="z-[0] shift-calendar" [options]="calendarOptions"></full-calendar>

      <div class="flex flex-col xs:flex-row gap-5 justify-between items-baseline mt-[1.5rem]">
        <h1 class="uppercase text-[#475569] font-bold text-3xl lg:text-4xl">{{"Shift templates" | translate}}</h1>

        <button mat-raised-button color="primary" class="text_color_white" matTooltip="{{'Create a new template' | translate}}"
        (click)="toggleAddShiftTemplatePopup(true)">
        <i class="fa-regular fa-circle-plus" style="font-size: 2vh; padding-right: 1vh;"></i>{{'Add shift template' | translate}}
        </button>
      </div>

      <div class="flex flex-col lg:grid lg:grid-cols-3 gap-[1.5rem] mt-[2rem]">

        <div class="h-full w-full bg-[#f5f8f9] rounded-xl shadow-sm border-solid border-[0.025rem]"
          *ngFor="let shiftTemplate of shiftTemplateData; index as i">
          <div class="flex flex-col justify-start gap-[.5rem] align-middle items-center w-full relative">
            <div
              class="flex flex-row gap-5 justify-between align-baseline items-center w-full h-full px-[1rem] py-[.35rem] bg-[#ffffff] rounded-t-xl">
              <span class="font-bold text-[1.5rem] text-left">{{(shiftTemplate.name ?? "" | truncate:(
                windowDimensions.width >= windowDimensions.threshold_3xl ? 32 : (windowDimensions.width >=
                windowDimensions.threshold_lg ? 10 : 50)))}}</span>

              <div class="flex flex-row justify-between gap-2">
                <button mat-icon-button (click)="toggleEditShiftTemplatePopup(true, shiftTemplate.id)">
                  <i class="fa-light fa-pencil fa-2xs text-[1.4rem]"></i>
                </button>

                <button mat-icon-button
                  (click)="toggleDeleteShiftTemplatePopup(true, shiftTemplate.id, 'shiftTemplate')">
                  <i class="fa-regular fa-trash-can fa-2xs text-[1.4rem]"></i>
                </button>
              </div>
            </div>

            <button *ngIf="shiftTemplate.workWeekList !== undefined && shiftTemplate.workWeekList!.length > 1"
              [disabled]="swiper.swiper.isBeginning" class="swiper-button-next absolute w-[3rem] h-[3rem] rounded-full z-[10] bottom-[.5rem] left-[1rem] 
            transition-all ease-in-out duration-200"
              [ngClass]="{'opacity-10 hover:cursor-auto pointer-events-none hover:opacity-10': 
            swiper.swiper.isBeginning, 'opacity-50 hover:cursor-pointer hover:opacity-100': !swiper.swiper.isBeginning}"
              (click)="swiper.swiper.slidePrev(); $event.preventDefault()">
              <i class="fa-solid fa-arrow-left text-[1.5rem] text-[#2c99b1]"></i>
            </button>

            <button *ngIf="shiftTemplate.workWeekList !== undefined && shiftTemplate.workWeekList!.length > 1"
              [disabled]="swiper.swiper.isEnd" class="swiper-button-next absolute w-[3rem] h-[3rem] rounded-full z-[10] bottom-[.5rem] right-[1rem] 
            transition-all ease-in-out duration-200" [ngClass]="{'opacity-10 hover:cursor-auto pointer-events-none hover:opacity-10': swiper.swiper.isEnd, 
            'opacity-50 hover:cursor-pointer hover:opacity-100': !swiper.swiper.isEnd}"
              (click)="swiper.swiper.slideNext(); $event.preventDefault()">
              <i class="fa-solid fa-arrow-right text-[1.5rem] text-[#2c99b1]"></i>
            </button>

            <div class="font-semibold text-[1.5rem] my-[.5rem] w-full text-start px-[1rem]">
              {{"Week" | translate}} {{swiper.swiper.activeIndex + 1}}
            </div>

            <swiper-container #swiper slides-per-view="1" grid-rows="1" space-between="20"
              [pagination]="paginationOptions" centered-slides="true" prevent-clicks="false"
              prevent-clicks-ropagation="false" initial-slide="0" mousewheel-force-to-axis="true"
              class="px-[1rem] w-full flex flex-col gap-3 mt-[0.5rem]">
              <swiper-slide *ngFor="let workWeek of shiftTemplate.workWeekList; let j = index"
                class="w-full overflow-y-auto" [ngClass]="{'max-h-[8rem] min-h-[8rem] mb-[4.5rem]': shiftTemplate.workWeekList !== undefined && shiftTemplate.workWeekList!.length > 1,
                          'max-h-[11rem] min-h-[11rem] mb-[1.5rem]': shiftTemplate.workWeekList !== undefined && shiftTemplate.workWeekList!.length <= 1,
                          'pr-0': sortedWorkingHours[i][j].length < 3,
                          'pr-[1rem]': sortedWorkingHours[i][j].length >= 3}">

                <div class="flex flex-col gap-3 w-full">

                  <div *ngFor="let group of sortedWorkingHours[i][j]" class="w-full">

                    <div class="flex flex-row justify-start gap-5 w-full">

                      <div class="flex flex-row justify-start gap-3 w-1/2">
                        {{ translate("DaysOfWeek." + group[0].dayOfWeek?.toString()) }}
                        <div class="flex flex-row gap-3" *ngIf="group.length > 1">
                          <p>-</p>
                          <p>{{translate("DaysOfWeek." + group[group.length - 1].dayOfWeek?.toString())}} </p>
                        </div>
                      </div>

                      <div class="w-1/2 flex flex-row justify-end font-semibold">
                        <p>
                          {{ group[0].fromTime | date : "HH:mm" }} -
                          {{ group[group.length - 1].toTime | date : "HH:mm" }}
                        </p>
                      </div>

                    </div>

                  </div>

                </div>

              </swiper-slide>
            </swiper-container>

          </div>
        </div>

      </div>

    </div>
  </div>

  <div sideNavContent class="w-full px-[1rem]">
    <mat-expansion-panel style="margin-top: 2vh;" *ngFor="let employee of userProfileData" hideToggle>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{employee.name}} {{employee.surname}}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div style="margin-bottom: 1rem;">
        <mat-divider></mat-divider>
      </div>

      <div class="flex flex-col gap-[1.25rem] w-full">
        <div class="flex flex-col w-full gap-3"
          *ngIf="employee.profileId !== undefined && employeeScheduleDataMap !== undefined && checkForKeyInEmployeeScheduleMap(employee.profileId)">
          <div class="flex justify-between w-full" *ngFor="let employeeScheduleData of employeeScheduleDataMap[employee.profileId]">
            <div class="text-[1.45rem] opacity-75">
              {{employeeScheduleData.startingFrom | date : "dd.MM.yyyy"}} -
              {{employeeScheduleData.endOn | date : "dd.MM.yyyy"}}
            </div>
            <div class="flex gap-5">
              <i class="fa-regular fa-pen-to-square text-[1.7rem] hover:cursor-pointer"
                (click)="toggleEditEmployeeSchedulePopup(true, employeeScheduleData); termsToCancel = undefined"></i>
              <i class="fa-regular fa-trash-can text-[1.7rem] hover:cursor-pointer"
                (click)="toggleDeleteEmployeeSchedulePopup(true, employeeScheduleData); termsToCancel = undefined"></i>
            </div>
          </div>
        </div>

        <div class="grid">
          <mat-list-item style="color: #b98d78;" *ngFor="let service of employee.employeeServicesList">
            <mat-icon matListIcon><i class="fa-solid fa-bookmark" style="color: #b98d78;"></i></mat-icon>
            {{service.serviceName}}
          </mat-list-item>
        </div>
      </div>

    </mat-expansion-panel>
  </div>

</app-generic-side-modal-container>

<!-- Add shift/priority popup -->
<app-generic-modal *ngIf="addShiftPopupState" [bannerText]="'add shift' | translate " [handle_extreme_overflow]="false"
  [handle_mobile]="true" (handleCloseEmitter)="closeShiftPopup()">
  <app-shift-add-popup (close)="closeShiftPopup()"></app-shift-add-popup>
</app-generic-modal>

<!-- Edit shift (Change employee for one day), in same component -->
<app-generic-modal #editShiftPopup *ngIf="editShiftPopupState"
  [bannerText]="(!allowEmployeeSwap ? ('preview shift' | translate) : ('change shift' | translate))"
  [handle_extreme_overflow]="false" [handle_mobile]="true" (handleCloseEmitter)="closeShiftPopup()">

  <div class="flex flex-col gap-5 text-black sm:max-w-[45rem]"
    [ngClass]="{'mt-[-.5rem] mb-[2.5rem]': allowEmployeeSwap}">
    <div class="flex flex-row justify-between gap-5">
      <p class="font-semibold">{{internalPreviewPopupStartTime | date : "dd.MM.yyyy"}}</p>
      <div class="flex flex-row gap-5">
        {{internalPreviewPopupStartTime?.getUTCHours()?.toString()?.padStart(2, '0') + ':' +
        internalPreviewPopupStartTime?.getUTCMinutes()?.toString()?.padStart(2, '0')}}
        <p>-</p>
        {{internalPreviewPopupEndTime?.getUTCHours()?.toString()?.padStart(2, '0') + ':' +
        internalPreviewPopupEndTime?.getUTCMinutes()?.toString()?.padStart(2, '0')}}
      </div>
    </div>

    <div class="bg-white w-full rounded-xl shadow-sm border-solid border-[0.025rem] p-[1rem]"
      *ngIf="replacedEmployeeData?.length! > 1 || !allowEmployeeSwap">
      <div class="flex flex-col gap-5 overflow-y-auto min-w-[45rem]" [ngClass]="{'pr-[1rem]': replacedEmployeeData !== null && replacedEmployeeData !== undefined && replacedEmployeeData.length >= 6 && allowEmployeeSwap,
                  'pr-[1.1rem]': replacedEmployeeData !== null && replacedEmployeeData !== undefined && replacedEmployeeData.length >= 18 && !allowEmployeeSwap,
                  'max-h-[20rem]': allowEmployeeSwap,
                  'max-h-[60rem]': !allowEmployeeSwap}">
        <div *ngFor="let employee of replacedEmployeeData"
          class="flex flex-row justify-between align-middle items-center">
          <div class="flex flex-row gap-3">
            <p>{{employee.name}}</p>
            <p>{{employee.surname}}</p>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!allowEmployeeSwap"
      class="bg-[#F9DEC0] mt-[1rem] rounded-md p-3 flex flex-row justify-between align-middle items-center gap-5 text-[#D94E4E] transition-all duration-200 ease-in-out">
      <div>
        <svg class="w-[22px] sm:w-[32px] h-[22px] sm:h-[32px]" xmlns="http://www.w3.org/2000/svg"
          viewBox="0 -960 960 960">
          <path fill="#D94E4E"
            d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
        </svg>
      </div>
      <div class="text-[0.85rem] sm:text-[1.35rem] w-full"> {{"Shift replacement passed date message" | translate }}
      </div>
    </div>
  </div>

  <form #replaceEmployee *ngIf="allowEmployeeSwap" #vacuForm="ngForm"
    class="flex flex-col gap-[1.35rem] mt-[.5rem] w-full justify-between align-middle sm:min-w-[45rem]">

    <div class="flex flex-col gap-1 w-full" *ngIf="showConfirmation==false">
      <mat-label>{{"Select employee who will be replaced" | translate}}</mat-label>
      <mat-form-field appearance="outline" class="flex flex-row items-center">
        <mat-icon matPrefix><i class="fa-regular fa-circle-user text-[2rem] pr-[1rem]"></i> </mat-icon>
        <mat-select placeholder='{{"Select employee" | translate}}'
          [value]="replacedEmployeeData !== undefined && replacedEmployeeData.length > 0 && replacedEmployeeData.length === 1 ? replacedEmployeeData![0].profileId : undefined"
          [(ngModel)]="replaceEmployeeData!.replacedEmployeeProfileId" name="toReplace"
          (selectionChange)="onEmployeeToReplaceSelectionChange($event)">
          <mat-option *ngFor="let employee of replacedEmployeeData" [value]="employee.profileId">
            {{employee.name}} {{employee.surname}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="flex flex-col gap-[1rem] mb-[1rem] sm:max-w-[45rem]">
      <div class="flex flex-row gap-5">
        <label class="relative inline-flex items-center cursor-pointer">
          <input #toggle type="checkbox"
          [value]="editingWorkDayScheduleWorkingState"
          [checked]="editingWorkDayScheduleWorkingState"
          (change)="editingWorkDayScheduleWorkingState = !editingWorkDayScheduleWorkingState"
          class="sr-only peer">
          <div
            class="w-[3rem] h-[1.65rem] bg-gray-200 peer-focus:outline-none
            peer-focus:ring-2 peer-focus:ring-[rgba(244,67,54,0.15)] rounded-full peer dark:bg-[#f44336] peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-[#f44336] peer-checked:bg-[#2c99b1]"></div>
        </label>
  
        <p class="font-normal text-[1rem] sm:text-[1.3rem] text-red-500 select-none hover:text-gray-500"
            (click)="editingWorkDayScheduleWorkingState = !editingWorkDayScheduleWorkingState"
            *ngIf="!editingWorkDayScheduleWorkingState">
          {{"schedule not working" | translate}}
        </p>
  
        <p class="font-normal text-[1rem] sm:text-[1.3rem] text-gray-500 select-none hover:text-red-500"
            (click)="editingWorkDayScheduleWorkingState = !editingWorkDayScheduleWorkingState"
            *ngIf="editingWorkDayScheduleWorkingState">
          {{"schedule working" | translate}}
        </p>
      </div>

      <div class="bg-[#F9DEC0] rounded-md p-3 flex flex-row justify-between opacity-100 align-middle items-center gap-3 text-[#D94E4E] w-full select-none transition-all duration-300 ease-in-out" 
      [ngClass]="{'opacity-50 select-none': editingWorkDayScheduleWorkingState}">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
            <path fill="#D94E4E" d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
          </svg>
        </div>
        <div class="text-[1.25rem] select-none">{{'if remove schedule no go back' | translate}}</div>
    </div>
    
    </div>

    <div class="flex flex-col gap-1 w-full" *ngIf="showConfirmation==false"
      [ngClass]="{'opacity-30 select-none pointer-events-none cursor-not-allowed': filteredReplacementEmployeeData!.length <= 0 || !editingWorkDayScheduleWorkingState}">
      <mat-label>{{"Select replacement" | translate}}</mat-label>
      <mat-form-field appearance="outline" class="flex flex-row items-center">
        <mat-icon matPrefix><i class="fa-regular fa-circle-user text-[2rem] pr-[1rem]"></i> </mat-icon>
        <mat-select placeholder='{{"Select employee" | translate}}'
          [value]="replacementEmployeeData?.length! === 1 ? replacementEmployeeData![0].profileId : null"
          [(ngModel)]="replaceEmployeeData!.replacementEmployeeProfileId" name="replaceWith"
          [disabled]="!hasChoseEmployeeToReplace || filteredReplacementEmployeeData!.length <= 0">
          <mat-option *ngFor="let employee of filteredReplacementEmployeeData" [value]="employee.profileId">
            {{employee.name}} {{employee.surname}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div *ngIf="filteredReplacementEmployeeData!.length <= 0" class="mt-[-2rem] text-[#f44336] select-none">
      <p> {{"No available replacements" | translate}} </p>
    </div>

    <div class="flex flex-col gap-1 w-full" *ngIf="showConfirmation==true">
      <mat-label>{{"There is already a replacement for that term, do you want to delete it and add the new replacement?"
        | translate}}</mat-label>
      <mat-form-field appearance="outline" class="flex flex-row items-center">
        <mat-icon matPrefix><i class="fa-sharp fa-regular fa-swatchbook text-[2rem] pr-[1rem]"></i> </mat-icon>
        <mat-select placeholder='{{"Select" | translate}}' [(ngModel)]="removeExist" name="name">
          <mat-option [value]="true">{{"Yes" | translate}}</mat-option>
          <mat-option [value]="false">{{"No" | translate}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-divider style="padding-bottom: 2vh;"></mat-divider>
    </div>

    <div class="flex flex-row gap-10 text-[1rem] sm:text-[1.35rem] pt-[1rem]">
      <button (click)="closeShiftPopup(); $event.preventDefault()"
        class="w-1/2 px-5 py-[.5rem] rounded-[.25rem] uppercase bg-[#dadada] text-[#696767] hover:bg-[#c4c4c4] shadow-md active:scale-[0.985] active:shadow-sm">
        {{ "BACK" | translate }}
      </button>

      <button 
        [disabled]="!vacuForm || ((!editingWorkDayScheduleWorkingState && (replaceEmployeeData === undefined || replaceEmployeeData!.replacedEmployeeProfileId === 0)) 
                              || (editingWorkDayScheduleWorkingState && (!hasChoseEmployeeToReplace || filteredReplacementEmployeeData!.length <= 0)))" 
        [ngClass]="{
          'bg-[#b98d78] hover:bg-[#a57d6a] active:scale-[0.985] active:shadow-sm': !(!vacuForm || ((!editingWorkDayScheduleWorkingState && (replaceEmployeeData === undefined || replaceEmployeeData!.replacedEmployeeProfileId === 0)) 
                              || (editingWorkDayScheduleWorkingState && (!hasChoseEmployeeToReplace || filteredReplacementEmployeeData!.length <= 0)))),
          'bg-[#b98d78]/20 hover:bg-[#a57d6a]/20': !vacuForm || ((!editingWorkDayScheduleWorkingState && (replaceEmployeeData === undefined || replaceEmployeeData!.replacedEmployeeProfileId === 0)) 
                              || (editingWorkDayScheduleWorkingState && (!hasChoseEmployeeToReplace || filteredReplacementEmployeeData!.length <= 0)))}"
        (click)="editingWorkDayScheduleWorkingState ? changeEmployeeShift() : removeEmployeeShift()"
        class="w-1/2 px-5 uppercase py-[.5rem] rounded-[.25rem] text-white shadow-md active:scale-[0.985] active:shadow-sm">
        {{"Save changes" | translate }}
      </button>
    </div>

  </form>

  <div class="flex flex-row justify-center align-middle items-center w-full mt-[2rem]">
    <button *ngIf="!allowEmployeeSwap" (click)="closeShiftPopup()"
      class="
    bg-[#b98d78] self-center hover:bg-[#a57d6a] w-1/3 px-5 py-[.5rem] uppercase rounded-[.25rem] text-white shadow-md active:scale-[0.985] active:shadow-sm">
      {{"Confirm viewing" | translate }}
    </button>
  </div>

</app-generic-modal>

<!-- Add and edit popups on shift template -->
<app-generic-modal *ngIf="addShiftTemplatePopupState || editShiftTemplatePopupState"
  [bannerText]="(!editShiftTemplatePopupState ? ('add template' | translate) : ('change template' | translate))"
  [handle_extreme_overflow]="false" [handle_mobile]="true" (handleCloseEmitter)="closeShiftTemplatePopup()">

  <app-shift-template-config-popup [editingMode]="editShiftTemplatePopupState" [shiftTemplateId]="shiftTemplateId"
    (close)="closeShiftTemplatePopup()">
  </app-shift-template-config-popup>

</app-generic-modal>

<!-- Delete template popup -->
<app-generic-modal *ngIf="deleteShiftTemplatePopupState" [bannerText]="'delete template' | translate "
  [handle_extreme_overflow]="false" [handle_mobile]="true" (handleCloseEmitter)="closeShiftTemplatePopup()">

  <app-delete-component (close)="closeShiftTemplatePopup()" [shiftTemplateId]="shiftTemplateId"
    [serviceName]="serviceName"></app-delete-component>

</app-generic-modal>

<!-- Edit Membership Type Popup -->
<app-generic-modal #editEmployeeSchedulePopup *ngIf="editEmployeeSchedulePopup" [bannerText]="'Edit Employee Schedule Popup' | translate"
  [handle_extreme_overflow]="false" [handle_mobile]="true"
  [modal_state_function]="toggleEditEmployeeSchedulePopup"
  (handleCloseEmitter)="toggleEditEmployeeSchedulePopup(false, undefined)">
  
  <div class="popup-anim flex flex-col gap-[2rem]" *ngIf="editingSchedule !== undefined && (termsToCancel === undefined || termsToCancel?.length! <= 0)">

    <div class="bg-white p-4 w-full rounded-xl border-solid border-[0.02rem]">
      <div class="text-[1.45rem] opacity-75 w-full">
        {{editingSchedule.startingFrom | date : "dd.MM.yyyy"}} -
        {{editingSchedule.endOn | date : "dd.MM.yyyy"}}
      </div>
    </div>

    <form #vacuForm="ngForm" class="flex flex-col gap-[1.35rem] mt-[.5rem] w-full justify-center align-middle sm:max-w-[50rem] sm:min-w-[45rem]">
  
      <div class="flex flex-col gap-1 w-full">
        <mat-label>{{"Select a date from" | translate}}</mat-label>
        <mat-form-field appearance="outline" class="flex flex-row items-center">
            <mat-icon matPrefix><i class="fa-regular fa-calendar text-[2rem] pr-[1rem]"></i> </mat-icon>
            <input matInput [matDatepicker]="picker" [(ngModel)]="updatingScheduleData.startingFrom" 
                [min]="findMinimumStartFromDate(editingSchedule)"
                placeholder='{{"DD/MM/YYYY" | translate}}' #date="ngModel" name="date" required>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="date && date.errors">
                <span *ngIf="date.errors['required']">{{"Required Field" | translate}}</span>
            </mat-error>
        </mat-form-field>
      </div>
  
      <div class="flex flex-col gap-1 w-full">
        <mat-label>{{"Select a date to" | translate}}</mat-label>
        <mat-form-field appearance="outline" class="flex flex-row items-center">
          <mat-icon matPrefix><i class="fa-regular fa-calendar text-[2rem] pr-[1rem]"></i> </mat-icon>
          <input matInput [matDatepicker]="secondPicker" [(ngModel)]="updatingScheduleData.endOn" 
            [min]="updatingScheduleData.startingFrom"
            placeholder='{{"DD/MM/YYYY" | translate}}' #endDate="ngModel" name="endDate" required>
            <mat-datepicker-toggle matSuffix [for]="secondPicker"></mat-datepicker-toggle>
            <mat-datepicker #secondPicker></mat-datepicker>
            <mat-error *ngIf="endDate && endDate.errors">
                <span *ngIf="endDate.errors['required']">{{"Required Field" | translate}}</span>
            </mat-error>
        </mat-form-field>
      </div>
  
      <div class="bg-[#F9DEC0] rounded-md p-3 flex flex-row justify-between align-middle items-center gap-5 text-[#D94E4E] transition-all duration-200 ease-in-out"
      [ngClass]="{'select-none opacity-35': !vacuForm.valid}">
        <div>
          <svg class="w-[22px] sm:w-[32px] h-[22px] sm:h-[32px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
            <path fill="#D94E4E" d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
          </svg>
        </div>
        <div class="text-[0.85rem] sm:text-[1.35rem] w-full"> {{"Changes to a employee schedule" | translate }} </div>
      </div>
  
      <div class="w-full flex flex-row gap-[0.85rem] justify-between align-middle items-center text-black">
        <mat-checkbox #confirmatioCheckbox [aria-label]="'confirmationCheckboxMobile'" class="text-wrap font-normal" [disabled]="!vacuForm.valid"></mat-checkbox>
        <p class="text-[0.85rem] sm:text-[1.35rem] w-full " [ngClass]="{'select-none opacity-35': !vacuForm.valid}">{{"agreement changes schedule update" | translate }}</p>
      </div>
      
      <div class="flex flex-row gap-10 text-[1rem] sm:text-[1.35rem] mt-[2rem]">
        <button (click)="onCloseEditEmployeeSchedulePopup(); $event.preventDefault()"
          class="w-1/2 px-5 py-[.5rem] rounded-[.25rem] bg-[#dadada] uppercase text-[#696767] hover:bg-[#c4c4c4] active:scale-[0.985] active:shadow-sm">
          {{'back' | translate}}
        </button>
  
        <button [disabled]="!confirmatioCheckbox.checked || !vacuForm.valid" [ngClass]="{
          'bg-[#b98d78] hover:bg-[#a57d6a] active:scale-[0.985] active:shadow-sm': confirmatioCheckbox.checked && (vacuForm.valid ?? true),
          'bg-[#b98d78]/20 hover:bg-[#a57d6a]/20': !confirmatioCheckbox.checked || !vacuForm.valid}" 
          (click)="termsToCancel === undefined ? prepareEditEmployeeSchedule(editingSchedule) : confirmEditEmployeeSchedule(editingSchedule, termsToCancel)" 
          class="w-1/2 px-5 uppercase py-[.5rem] rounded-[.25rem] text-white shadow-md active:scale-[0.985] active:shadow-sm">
          {{"Save changes" | translate }}
        </button>
      </div>
  
    </form>
  </div>

  <div class="flex flex-col justify-center gap-[1rem] items-center align-middle md:max-w-[50rem] popup-anim" 
  *ngIf="editingSchedule !== undefined && termsToCancel !== undefined && termsToCancel.length > 0">
    <div class="questionmark_icon w-[8rem] h-[8rem] self-center mt-[-1rem]"> </div>
    <div class="bg-[#F9DEC0] rounded-md p-3 flex flex-row justify-between align-middle items-center gap-3 text-[#D94E4E]">
      <div>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
          <path fill="#D94E4E" d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
        </svg>
      </div>
      <div class="text-[1.25rem]"> {{"if edit schedule terms will be cancelled" | translate }} </div>
    </div>

    <div class="p-[1.5rem] border-2 border-[#B98D78] w-full h-full rounded-lg flex flex-col gap-5 overflow-auto max-h-[30rem] text-black">
      <div *ngFor="let term of termsToCancel" class="flex flex-col gap-2 bg-[#f7f7f8] p-3 shadow-sm rounded-md">
        <div class="flex flex-row gap-1">
          <div class="uppercase text-[1.5rem] font-bold text-black">{{ term.serviceName }}</div>
          <div> {{"-"}} {{ term.fromDate | date : 'dd.MM.yyyy' }} {{"|"}} {{ term.fromDate | date : 'HH:mm' }} - {{ term.toDate | date : 'HH:mm' }}</div>
        </div>

        <div class="flex flex-col gap-2">
          <div class="flex flex-row gap-1 text-[#B98D78]">
            <div class="text-[#767474]"> {{"client" | translate }} </div>
            <div> {{ term.name }} {{ term.surname }} </div>
          </div>

          <div class="flex flex-row gap-1">
            <div class="text-[#767474]"> {{"employee" | translate }} </div>
            <div class="italic"> {{ term.employeeName }} {{ term.employeeSurname }} </div>
          </div>
        </div>

      </div>
    </div>

    <div class="flex flex-row gap-10 text-[1rem] sm:text-[1.35rem] mt-[2rem] w-full">
      <button (click)="termsToCancel = undefined; $event.preventDefault()"
        class="w-1/2 px-5 py-[.5rem] rounded-[.25rem] bg-[#dadada] uppercase text-[#696767] hover:bg-[#c4c4c4] active:scale-[0.985] active:shadow-sm">
        {{'back' | translate}}
      </button>

      <button (click)="confirmEditEmployeeSchedule(editingSchedule, termsToCancel)" 
        class="w-1/2 px-5 uppercase py-[.5rem] rounded-[.25rem] text-white shadow-md active:scale-[0.985] active:shadow-sm bg-[#b98d78] hover:bg-[#a57d6a]">
        {{"Save changes" | translate }}
      </button>
    </div>
  </div>

</app-generic-modal>

<!-- Delete Membership Type Popup -->
<app-generic-modal #deleteEmployeeSchedulePopup *ngIf="deleteEmployeeSchedulePopup"
  [bannerText]="'Delete Employee Schedule Popup' | translate" [handle_extreme_overflow]="false" [handle_mobile]="true"
  [modal_state_function]="toggleDeleteEmployeeSchedulePopup"
  (handleCloseEmitter)="toggleDeleteEmployeeSchedulePopup(false, undefined)">

  <div class="box width_100_percent">
    <div class="popup-anim" *ngIf="editingSchedule !== undefined && (termsToCancel === undefined || termsToCancel?.length! <= 0)">
      <div>
        <div class="flex flex-col gap-5">
          <div class="flex flex-col center gap-1">
            <lord-icon src="https://cdn.lordicon.com/drxwpfop.json" trigger="hover"
              colors="primary:#b4b4b4,secondary:#b98d78" style="width:150px;height:150px">
            </lord-icon>
          </div>
  
          <div class="flex flex-col center gap-1 padding_20 text-center">
            <mat-label>{{"Delete schedule" | translate}}</mat-label>
          </div>
        </div>
      </div>
  
      <div class="bg-white p-4 w-full mb-8 rounded-xl border-solid border-[0.02rem]">
        <div class="flex justify-between">
          <div class="font-bold">{{editingSchedule.name}} {{editingSchedule.surname}}</div>
        </div>
  
        <div class="text-[1.45rem] opacity-75">
          {{editingSchedule.startingFrom | date : "dd.MM.yyyy"}} -
          {{editingSchedule.endOn | date : "dd.MM.yyyy"}}
        </div>
      </div>
    </div>

    <div class="flex flex-col justify-center gap-[1rem] items-center align-middle md:max-w-[50rem] popup-anim" 
    *ngIf="editingSchedule !== undefined && termsToCancel !== undefined && termsToCancel.length > 0">
      <div class="questionmark_icon w-[8rem] h-[8rem] self-center mt-[-1rem]"> </div>
      <div class="bg-[#F9DEC0] rounded-md p-3 flex flex-row justify-between align-middle items-center gap-3 text-[#D94E4E]">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
            <path fill="#D94E4E" d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
          </svg>
        </div>
        <div class="text-[1.25rem]"> {{"if cancel schedule terms will be cancelled" | translate }} </div>
      </div>
  
      <div class="p-[1.5rem] border-2 border-[#B98D78] w-full h-full rounded-lg flex flex-col gap-5 overflow-auto max-h-[30rem] text-black">
        <div *ngFor="let term of termsToCancel" class="flex flex-col gap-2 bg-[#f7f7f8] p-3 shadow-sm rounded-md">
          <div class="flex flex-row gap-1">
            <div class="uppercase text-[1.5rem] font-bold text-black">{{ term.serviceName }}</div>
            <div> {{"-"}} {{ term.fromDate | date : 'dd.MM.yyyy' }} {{"|"}} {{ term.fromDate | date : 'HH:mm' }} - {{ term.toDate | date : 'HH:mm' }}</div>
          </div>
  
          <div class="flex flex-col gap-2">
            <div class="flex flex-row gap-1 text-[#B98D78]">
              <div class="text-[#767474]"> {{"client" | translate }} </div>
              <div> {{ term.name }} {{ term.surname }} </div>
            </div>
  
            <div class="flex flex-row gap-1">
              <div class="text-[#767474]"> {{"employee" | translate }} </div>
              <div class="italic"> {{ term.employeeName }} {{ term.employeeSurname }} </div>
            </div>
          </div>
  
        </div>
      </div>
    </div>

    <div class="flex flex-row gap-10 text-[1rem] sm:text-[1.35rem] mt-[2rem]">
      <button (click)="onCloseDeleteEmployeeSchedulePopup(); $event.preventDefault()"
        class="w-1/2 px-5 py-[.5rem] rounded-[.25rem] bg-[#dadada] uppercase text-[#696767] hover:bg-[#c4c4c4] active:scale-[0.985] active:shadow-sm">
        {{'back' | translate}}
      </button>

      <button (click)="termsToCancel === undefined ? prepareDeleteEmployeeSchedule(editingSchedule) : confirmDeleteEmployeeSchedule(editingSchedule, termsToCancel)"
        class="w-1/2 bg-[#b98d78] hover:bg-[#a57d6a] px-5 uppercase py-[.5rem] rounded-[.25rem] text-white shadow-md active:scale-[0.985] active:shadow-sm">
        {{'save' | translate}}
      </button>
    </div>

  </div>
</app-generic-modal>